export default __webpack_public_path__ + "static/media/crs1.eaae4757.jpg";